import LinkedInLogo from "../LogoSVG/LinkedInLogo";
import TelegramLogo from "../LogoSVG/TelegramLogo";
import GithubLogo from "../LogoSVG/GithubLogo";
import LeetcodeLogo from "../LogoSVG/LeetcodeLogo";
import EmailLogo from "../LogoSVG/EmailLogo";

import FooterMobile from "../Footer/FooterMobile";
import ConnectMobileItem from "./ConnectMobileItem";

function ConnectMobile() {
  return (
    <section id="connect" className=" pt-[75px] pb-[60px]">
      <div className="container items-start mb-16">
        <div className="flex flex-row items-center">
          <p className="text-xl font-bold mb-8">CONNECT</p>
        </div>

        <ConnectMobileItem
          Logo={EmailLogo}
          url="mailto:lnqminh3003@gmail.com"
          name="Collaborations"
        />

        <ConnectMobileItem
          Logo={GithubLogo}
          url="https://github.com/lnqminh3003"
          name="Github"
        />

        <ConnectMobileItem
          Logo={LeetcodeLogo}
          url="https://leetcode.com/u/minhle3003/"
          name="Leetcode"
        />

        <ConnectMobileItem
          Logo={LinkedInLogo}
          url="https://www.linkedin.com/in/minhle3003/"
          name="LinkedIn"
        />

        <ConnectMobileItem
          Logo={TelegramLogo}
          url="https://t.me/lnqminh"
          name="Telegram"
        />
      </div>

      <FooterMobile />
    </section>
  );
}

export default ConnectMobile;
